<template>

    <div class="MatchDetailPlayer__wrapper">

        <div class="MatchDetailPlayer__holder">

            <div class="MatchDetailPlayer__team">

                <div class="MatchDetailPlayer">
                    <div class="MatchDetailPlayer__rank" v-if="getRank(info.idA)">
                        {{getRank(info.idA)}}
                        <!-- <div class="MatchDetailPlayer__rank__label" v-if="info.isDoubles == '1'">Doubles<br>ranking
                        </div>
                        <div class="MatchDetailPlayer__rank__label" v-else>Singles<br>ranking</div> -->
                    </div>
                    <div class="MatchDetailPlayer__name"><span class="MatchDetailPlayer__name__fn">{{info.nAF}}</span><span class="MatchDetailPlayer__name__i">{{initial(info.nAF)}}</span>&nbsp;{{info.nAL}}</div>
                </div>

                <div class="MatchDetailPlayer" v-if="info.isDoubles == '1'">
                    <div class="MatchDetailPlayer__rank" v-if="getRank(info.idA2)">
                        {{getRank(info.idA2)}}
                        <!-- <div class="MatchDetailPlayer__rank__label">Doubles<br>ranking</div> -->
                    </div>
                    <div class="MatchDetailPlayer__name"><span class="MatchDetailPlayer__name__fn">{{info.nA2F}}</span><span class="MatchDetailPlayer__name__i">{{initial(info.nA2F)}}</span>&nbsp;{{info.nA2L}}</div>
                </div>

            </div>

            <div class="MatchDetailPlayer__team">

                <div class="MatchDetailPlayer">
                    <div class="MatchDetailPlayer__name"><span class="MatchDetailPlayer__name__fn">{{info.nBF}}</span><span class="MatchDetailPlayer__name__i">{{initial(info.nBF)}}</span>&nbsp;{{info.nBL}}</div>

                    <div class="MatchDetailPlayer__rank MatchDetailPlayer__rank--right" v-if="getRank(info.idB)">
                        {{getRank(info.idB)}}
                        <!-- <div class="MatchDetailPlayer__rank__value"></div> -->
                        <!-- <div class="MatchDetailPlayer__rank__label" v-if="info.isDoubles == '1'">Doubles<br>ranking
                        </div>
                        <div class="MatchDetailPlayer__rank__label" v-else>Singles<br>ranking</div> -->
                    </div>
                </div>

                <div class="MatchDetailPlayer" v-if="info.isDoubles == '1'">
                    <div class="MatchDetailPlayer__name"><span class="MatchDetailPlayer__name__fn">{{info.nB2F}}</span><span class="MatchDetailPlayer__name__i">{{initial(info.nB2F)}}</span>&nbsp;{{info.nB2L}}</div>

                    <div class="MatchDetailPlayer__rank MatchDetailPlayer__rank--right" v-if="getRank(info.idB2)">
                        {{getRank(info.idB2)}}
                        <!-- <div class="MatchDetailPlayer__rank__value"></div> -->
                        <!-- <div class="MatchDetailPlayer__rank__label">Doubles<br>ranking</div> -->
                    </div>
                </div>

            </div>

        </div>

        <!-- <div class="MatchDetailH2H" v-if="info.isDoubles == '0'">
            <div class="MatchDetailH2H__caption">
                Career Head2Head
            </div>

            <div class="MatchDetailH2H__stat">
                <div class="MatchDetailH2H__stat__caption" v-if="playerH2HPercent(0)">{{playerH2HPercent(0)}}%<br>Wins
                </div>
                <div class="MatchDetailH2H__stat__value">{{playerH2H(0)}}/{{playerH2H(1)}}</div>
                <div class="MatchDetailH2H__stat__caption" v-if="playerH2HPercent(1)">{{playerH2HPercent(1)}}%<br>wins
                </div>
            </div>
        </div> -->

        <div class="MatchDetail__stat__caption">Match Statistics</div>

    </div>


</template>

<script>
    import axios from 'axios'

    export default {
        props: ['info', 'match', 'assoc', 'tournament'],
        data() {
            return {
                tournament_slug: this.tournament,
                players: window.all_players,
                h2h: []
            }
        },
        created() {
            this.getH2H()
        },
        methods: {
            getH2H() {

                axios.get(`${window.feed_ip}/get/${this.assoc}/${this.tournament_slug}/${this.match}-h2h`).then(response => {

                    this.h2h = response.data

                }).catch(function (error) {
                    console.log(error);
                });

            },
            playerH2H(player) {

                if (this.h2h == null) {
                    return '-'
                }

                if (this.h2h[player] == null) {
                    return '-'
                }

                return this.h2h[player]

            },
            playerH2HPercent(player) {

                if (this.h2h == null) {
                    return false
                }

                if (this.h2h[player] == null) {
                    return false
                }

                if (this.h2h[player] == '0') {
                    return '0'
                }

                return Math.round(parseInt(this.h2h[player]) / (parseInt(this.h2h[0]) + parseInt(this.h2h[1])) * 100)

            },
            getRank(playerId) {
                let player = this.findPlayerById(playerId)

                if (!player) {
                    return 'N/A'
                }

                if (this.info.isDoubles == '1') {
                    return 'rank ' + player.double_rank
                }

                return 'rank ' + player.single_rank

            },
            initial(name) {
                return `${name.charAt(0)}.`
            },
            findPlayerById(playerId) {
                let found = this.players.filter(player => player.player_id == playerId)

                if (found.length == 1) {
                    return found[0]
                }

                return false
            }
        }
    }
</script>
